export default (theme) => ({
  profileForm: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column',
    },
  },
  multiInputsWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
  },
  field: {
    width: 'calc(50% - 20px)',
    marginBottom: 20,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  addressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      marginBottom: 20,
    },
  },
  preferredCommunication: {
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      marginBottom: 20,
    },
  },
  preferredCommunicationLabel: {
    marginTop: 5,
    color: theme.palette.font.main,
  },
  checkboxOption: {
    width: 'auto',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    '&:last-of-type': {
      marginRight: 0,
    },
  },
});
